import loadable from '@loadable/component';

export const OrgDashboardViewJobPageLoadable = loadable(
  () => import('./OrgDashboardViewJobPage'),
  { resolveComponent: (module) => module.OrgDashboardViewJobPage },
);
